import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { EpochsComposite } from "@/domains/analytics/components/epochs/epochs-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"
import { AnalyticsPagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/analytics-pages-complex-breadcrumb-application"

const BREADCRUMB_ITEMS = [
  createBreadcrumbItem("more", "More", "/"),
  createBreadcrumbItem("analytics", "Analytics", "/analytics"),
  AnalyticsPagesComplexBreadcrumbApplication,
]

export default function AnalyticsEpochsPage() {
  return (
    <PageContainer>
      <MetaData title="Epochs | Analytics" />
      <PageTitle
        title="Epochs"
        subTitle="Protocol epoch analytics"
        items={BREADCRUMB_ITEMS}
      />
      <EpochsComposite />
    </PageContainer>
  )
}
